/**
 * Angular imports.
 */
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Component imports.
 */
import { EventModalComponent } from './event-modal.component';


@NgModule({
  declarations: [
    EventModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    EventModalComponent
  ]
})
export class EventsModalModule { }
